/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import * as React from 'react';

export const Devops = () => {
  return (
    <svg viewBox="0 0 48 38" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M22.206 35.5371C28.3729 34.4477 33.4664 33.5463 33.5249 33.5339L33.6312 33.5113L27.8091 26.586C24.6069 22.7772 21.9869 19.646 21.9869 19.628C21.9869 19.5938 27.9988 3.03843 28.0326 2.97949C28.0439 2.95984 32.1352 10.0233 37.9501 20.1018C43.3941 29.5374 47.8824 37.3172 47.9241 37.3901L48 37.5226L29.4967 37.5202L10.9935 37.5179L22.206 35.5371ZM0 33.4253C0 33.4155 2.74337 28.6532 6.09637 22.8424L12.1927 12.2773L19.2974 6.31513C23.2049 3.03592 26.4125 0.348913 26.4254 0.343878C26.4382 0.339113 26.3868 0.468487 26.3111 0.631512C26.2354 0.794538 22.7639 8.2407 18.5965 17.1785L11.0195 33.4292L5.50976 33.4361C2.47939 33.4399 0 33.435 0 33.4253Z"/>
    </svg>

  );
}
